module.exports = __webpack_public_path__ + "img/input_gene.f6002df1.png";